// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host { display: contents; }

.ep-drawer {
    position: fixed;
    top: 0; left: 0; bottom: 0;
    width: min(460px, 90vw);
    background: var(--bg-primary, #fff);
    color: var(--text-primary, #222);
    border-right: 1px solid var(--border-color, #e0e0e0);
    box-shadow: 8px 0 24px rgba(0, 0, 0, 0.18);
    z-index: 1240;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 0.18s ease;
}
.ep-drawer.open { transform: translateX(0); }

.ep-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    border-bottom: 1px solid var(--border-color, #e8e8e8);
    background: var(--bg-secondary, #f7f7f7);
    flex-shrink: 0;
}

.ep-title {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    font-weight: 700;
    font-family: monospace;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ep-status-badge {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: var(--text-secondary, #888);
}

.ep-refresh-btn, .ep-close-btn {
    all: unset;
    cursor: pointer;
    font-size: 14px;
    color: var(--text-secondary, #888);
    padding: 2px 4px;
    flex-shrink: 0;
}
.ep-refresh-btn:hover, .ep-close-btn:hover { color: var(--text-primary, #333); }

.ep-body {
    flex: 1;
    overflow-y: auto;
    padding: 14px 16px;
    font-size: 13px;
    line-height: 1.5;
}

.ep-status {
    font-size: 12px;
    color: var(--text-secondary, #888);
    font-style: italic;
}
.ep-status-error { color: var(--danger, #c0392b); font-style: normal; }

p { margin: 0 0 8px; }
p:last-child { margin-bottom: 0; }
ul { margin: 0 0 8px 18px; padding: 0; }
code { background: var(--bg-secondary, #f0f0f0); padding: 1px 4px; border-radius: 3px; font-size: 12px; }
`, "",{"version":3,"sources":["webpack://./src/explain-panel.css"],"names":[],"mappings":"AAAA,QAAQ,iBAAiB,EAAE;;AAE3B;IACI,eAAe;IACf,MAAM,EAAE,OAAO,EAAE,SAAS;IAC1B,uBAAuB;IACvB,mCAAmC;IACnC,gCAAgC;IAChC,oDAAoD;IACpD,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,gCAAgC;AACpC;AACA,kBAAkB,wBAAwB,EAAE;;AAE5C;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,qDAAqD;IACrD,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;AAClB;AACA,6CAA6C,gCAAgC,EAAE;;AAE/E;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,kBAAkB;AACtB;AACA,mBAAmB,6BAA6B,EAAE,kBAAkB,EAAE;;AAEtE,IAAI,eAAe,EAAE;AACrB,eAAe,gBAAgB,EAAE;AACjC,KAAK,oBAAoB,EAAE,UAAU,EAAE;AACvC,OAAO,wCAAwC,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE","sourcesContent":[":host { display: contents; }\n\n.ep-drawer {\n    position: fixed;\n    top: 0; left: 0; bottom: 0;\n    width: min(460px, 90vw);\n    background: var(--bg-primary, #fff);\n    color: var(--text-primary, #222);\n    border-right: 1px solid var(--border-color, #e0e0e0);\n    box-shadow: 8px 0 24px rgba(0, 0, 0, 0.18);\n    z-index: 1240;\n    display: flex;\n    flex-direction: column;\n    transform: translateX(-100%);\n    transition: transform 0.18s ease;\n}\n.ep-drawer.open { transform: translateX(0); }\n\n.ep-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 14px;\n    border-bottom: 1px solid var(--border-color, #e8e8e8);\n    background: var(--bg-secondary, #f7f7f7);\n    flex-shrink: 0;\n}\n\n.ep-title {\n    flex: 1;\n    min-width: 0;\n    font-size: 13px;\n    font-weight: 700;\n    font-family: monospace;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.ep-status-badge {\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    color: var(--text-secondary, #888);\n}\n\n.ep-refresh-btn, .ep-close-btn {\n    all: unset;\n    cursor: pointer;\n    font-size: 14px;\n    color: var(--text-secondary, #888);\n    padding: 2px 4px;\n    flex-shrink: 0;\n}\n.ep-refresh-btn:hover, .ep-close-btn:hover { color: var(--text-primary, #333); }\n\n.ep-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 14px 16px;\n    font-size: 13px;\n    line-height: 1.5;\n}\n\n.ep-status {\n    font-size: 12px;\n    color: var(--text-secondary, #888);\n    font-style: italic;\n}\n.ep-status-error { color: var(--danger, #c0392b); font-style: normal; }\n\np { margin: 0 0 8px; }\np:last-child { margin-bottom: 0; }\nul { margin: 0 0 8px 18px; padding: 0; }\ncode { background: var(--bg-secondary, #f0f0f0); padding: 1px 4px; border-radius: 3px; font-size: 12px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
